import { cn } from '@/lib/utils';

/** The Taim clock mark, drawn in the workspace theme's primary colour (decorative: the name sits next to it). */
export function TaimLogo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" data-testid="taim-logo" className={cn('size-6', className)}>
      <circle cx="16" cy="16" r="14" fill="var(--primary)" />
      <path
        d="M16 8v8l5 3"
        stroke="var(--primary-foreground)"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** The same mark as a standalone SVG (for the favicon), in a concrete colour. */
export function logoDataUrl(primary: string, foreground = '#ffffff'): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="14" fill="${primary}"/><path d="M16 8v8l5 3" stroke="${foreground}" stroke-width="3" fill="none" stroke-linecap="round"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
